import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import { string, object, boolean } from "yup";

translator.getLanguages();

const emailTextRegex = /@[^.]*\./;
const inputTextRegex = /^[a-zа-яё]+$/i;
const agreementError = translator.t(
    "main",
    'To successfully register, you must check the boxes "I have read the User Agreement" and "I consent to the processing of personal data"'
);

const schema = object({
	email: string()
		.required(
			translator.t("user", '"{field}" is required', { field: translator.t("main", "Email") })
		)
		.email(translator.t("user", 'The value "E-mail" is not an email address'))
		.matches(
			emailTextRegex,
			translator.t("user", 'The value "E-mail" is not an email address')
		),
	first: string()
		.required(
			translator.t("user", '"{field}" is required', { field: translator.t("user", "First") })
		)
		.min(
			2,
			translator.t("user", 'The value "{field}" must be at least {n} characters ', {
				field: translator.t("user", "First"),
				n: 2,
			})
		)
		.max(
			30,
			translator.t("user", 'The value "{field}" must contain a maximum of {n} characters ', {
				field: translator.t("user", "First"),
				n: "30",
			})
		)
		.matches(
			inputTextRegex,
			translator.t("user", 'The value "{field}" must consist of letters', {
				field: translator.t("user", "First"),
			})
		),
	second: string()
		.required(
			translator.t("user", '"{field}" is required', { field: translator.t("user", "Second") })
		)
		.min(
			2,
			translator.t("user", 'The value "{field}" must be at least {n} characters ', {
				field: translator.t("user", "Second"),
				n: "2",
			})
		)
		.max(
			30,
			translator.t("user", 'The value "{field}" must contain a maximum of {n} characters ', {
				field: translator.t("user", "Second"),
				n: "30",
			})
		)
		.matches(
			inputTextRegex,
			translator.t("user", 'The value "{field}" must consist of letters', {
				field: translator.t("user", "Second"),
			})
		),
	middle: string()
		.max(
			30,
			translator.t("user", 'The value "{field}" must contain a maximum of {n} characters ', {
				field: translator.t("user", "Middle"),
				n: "30",
			})
		)
		.matches(
			inputTextRegex,
			translator.t("user", 'The value "{field}" must consist of letters', {
				field: translator.t("user", "Middle"),
			})
		),
	phone: string()
		.required(
			translator.t("user", '"{field}" is required', { field: translator.t("user", "Phone") })
		)
		.test(
			"len",
			translator.t("user", '"{field}" is required', { field: translator.t("user", "Phone") }),
			val => val.length === 16
		),
	agree: boolean().oneOf([true], agreementError),
	userAgreement: boolean().oneOf([true], agreementError),
});

export default schema;
